import { VODCSSModules } from 'shared/utils/wix-connect';

import Icon from 'shared/components/icon/icon';

import styles from './menu-button.styl';

@VODCSSModules(styles)
export default class MenuButton extends React.Component {
  static propTypes = {
    onClick: React.PropTypes.func,
    className: React.PropTypes.func,
  };

  render() {
    const { onClick, className } = this.props;

    return (
      <Icon name="menu"
            onClick={onClick}
            className={className}
            styleName="button icon" />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/menu-button/menu-button.js